/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { cloneDeep } from 'lodash'
import moment from 'moment'

import { API } from '../api/api'
import { fetch, post, put, remove } from '../api/httpClient'
import {
  CANVAS,
  DATEFORMAT,
  DATEFORMATWITHTIME,
  MESSAGE_SEVERITIES,
  TIMEFORMAT,
  UsPhoneCode,
} from '../helpers/constants'
import {
  convertTimestampToDate,
  formatDate,
  get,
  getDashAddedPhone,
  getDashRemovedPhone,
  isEmpty,
  isNullOrEmpty,
} from './../helpers/utils'
import { messageAction } from './app.action'

const modifyUpdateCall = (data) => {
  const updatedata = cloneDeep(data)
  if (updatedata.mobile_phone) {
    updatedata.mobile_phone = updatedata.mobile_phone
      ? getDashRemovedPhone(updatedata.mobile_phone)
      : ''
  }
  if (updatedata?.address?.adr_mobile) {
    updatedata.address.adr_mobile = updatedata?.address.adr_mobile
      ? getDashRemovedPhone(updatedata?.address.adr_mobile)
      : ''
  }
  if (updatedata?.address?.adr_phone) {
    updatedata.address.adr_phone = updatedata?.address.adr_phone
      ? getDashRemovedPhone(updatedata?.address.adr_phone)
      : ''
  }
  if (updatedata.parents) {
    for (const p of updatedata.parents) {
      if (p.home_phone_number) {
        p.home_phone_number = p?.home_phone_number ? getDashRemovedPhone(p.home_phone_number) : ''
      }
      if (p.primary_phone_number) {
        p.primary_phone_number = p?.primary_phone_number
          ? getDashRemovedPhone(p.primary_phone_number)
          : ''
      }
    }
  }
  return updatedata
}

export const updateUserCall = (email, payload, successCallback, failureCallback) => async () => {
  try {
    const updatedata = modifyUpdateCall(payload)
    const { address, parents, ...rest } = updatedata
    const url = `${API.CUSTOMER}/${email}`
    let updatedPayloads = { ...rest }
    if (payload.suffix) {
      updatedPayloads = {
        ...updatedPayloads,
        suffix: rest?.suffix === 'none' ? '' : rest?.suffix,
      }
    }
    if (payload.email) {
      updatedPayloads = {
        ...updatedPayloads,
        email: rest?.email?.toLowerCase()?.trim(),
      }
    }
    if (payload.dob) {
      updatedPayloads = {
        ...updatedPayloads,
        dob: `${moment(rest.dob).format(DATEFORMAT)}`,
        // dob: rest.dob && typeof rest.dob === 'object' ? rest.dob.getTime() : rest.dob,
      }
    }
    const formPayload = new FormData()
    Object.keys(updatedPayloads).forEach((key) => {
      formPayload.append(key, updatedPayloads[key])
    })
    if (!isEmpty(address)) {
      Object.keys(address).forEach((key) => {
        if (key === 'email') {
          formPayload.append(`address[${key}]`, address[key]?.toLowerCase()?.trim())
        } else if (key === 'adr_email') {
          formPayload.append(`address[${key}]`, address[key]?.toLowerCase()?.trim())
        } else formPayload.append(`address[${key}]`, address[key])
      })
    }
    if (!isEmpty(parents)) {
      parents.forEach((parent, i) => {
        Object.keys(parent).forEach((key) => {
          if (key === 'email') {
            formPayload.append(`parents[${i}][${key}]`, parent[key]?.toLowerCase()?.trim())
          } else if (key === 'dob') {
            formPayload.append(`parents[${i}][${key}]`, moment(parent[key]).format(DATEFORMAT))
          } else {
            formPayload.append(`parents[${i}][${key}]`, parent[key])
          }
        })
      })
    }
    const { data } = await put(url, formPayload)
    modifyUserItem(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const updateUserDetailsCall =
  (email, payload, successCallback, failureCallback) => async () => {
    try {
      const updatedata = modifyUpdateCall(payload)
      const { address, parents, ...rest } = updatedata
      const url = `${API.PARENT}/${email}`
      let updatedPayloads = { ...rest }
      if (payload.suffix) {
        updatedPayloads = {
          ...updatedPayloads,
          suffix: rest?.suffix === 'none' ? '' : rest?.suffix,
        }
      }
      if (payload.email) {
        updatedPayloads = {
          ...updatedPayloads,
          email: rest?.email?.toLowerCase()?.trim(),
        }
      }
      if (payload.dob) {
        updatedPayloads = {
          ...updatedPayloads,
          dob: `${moment(rest.dob).format(DATEFORMAT)}`,
          // dob: rest.dob && typeof rest.dob === 'object' ? rest.dob.getTime() : rest.dob,
        }
      }
      const formPayload = new FormData()
      Object.keys(updatedPayloads).forEach((key) => {
        formPayload.append(key, updatedPayloads[key])
      })
      if (!isEmpty(address)) {
        Object.keys(address).forEach((key) => {
          if (key === 'email') {
            formPayload.append(`address[${key}]`, address[key]?.toLowerCase()?.trim())
          } else if (key === 'adr_email') {
            formPayload.append(`address[${key}]`, address[key]?.toLowerCase()?.trim())
          } else formPayload.append(`address[${key}]`, address[key])
        })
      }
      if (!isEmpty(parents)) {
        parents.forEach((parent, i) => {
          Object.keys(parent).forEach((key) => {
            if (key === 'email') {
              formPayload.append(`parents[${i}][${key}]`, parent[key]?.toLowerCase()?.trim())
            } else if (key === 'dob') {
              formPayload.append(`parents[${i}][${key}]`, moment(parent[key]).format(DATEFORMAT))
            } else {
              formPayload.append(`parents[${i}][${key}]`, parent[key])
            }
          })
        })
      }
      const { data } = await put(url, formPayload)
      modifyUserItem(data)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

////////////////////////////////////////////////////////////////---Files Actions Start---///////////////////////////////////////////////////////////////////////////

export const fetchFilesCall =
  (userUrn, pageDetails, successCallback, failureCallback) => async () => {
    try {
      if (isEmpty(userUrn)) {
        return
      }
      const url = `${API.CORE.UPLOADFILES}/file?page=${pageDetails.current_page || ''}&perPage=${
        pageDetails.per_page || ''
      }&sortBy=${pageDetails.sort_by}&sortOrder=${pageDetails.sort_order}&urn=${userUrn}&search=${
        pageDetails.q || ''
      }`
      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyFiles(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const uploadFilesCall =
  (userUrn, payload, successCallback, failureCallback) => async (dispatch) => {
    const apiPath = `${API.CORE.UPLOADFILES}/file/upload`
    try {
      const {
        fl_urn = userUrn,
        fl_file_name,
        fl_description,
        file,
        type,
        fl_file_alias_name,
      } = payload
      const updatedPayload = new FormData()
      updatedPayload.append('fl_urn', fl_urn)
      updatedPayload.append('fl_file_name', fl_file_name)
      updatedPayload.append('fl_description', fl_description)
      updatedPayload.append('file', file)
      updatedPayload.append('type', type)
      updatedPayload.append('fl_file_alias_name', fl_file_alias_name)

      const { data } = await put(apiPath, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:fileUploaded',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const deleteFilesCall = (ids, successCallback, errorCallback) => async (dispatch) => {
  try {
    const apiPath = `${API.CORE.UPLOADFILES}/file/${ids.join(',')}`
    const response = await remove(apiPath, {})
    dispatch(
      messageAction({
        subTitle: 'message:filesDeleted',
        severity: MESSAGE_SEVERITIES.SUCCESS,
      })
    )
    successCallback(response.data)
  } catch (err) {
    if (typeof errorCallback === 'function') {
      errorCallback(err)
    }
  }
}

////////////////////////////////////////////////////////////////---Files Actions End---///////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////---FERPA FOR Actions start---///////////////////////////////////////////////////////////////////////////
export const fetchFerpaListCall = (userUrn, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.FERPA}?studentUrn=${userUrn}`
    const { data } = await fetch(url)
    data.forEach((dataitem) => modifyGetCall(dataitem))
    // get(data, 'content', []).forEach((item) => modifyFiles(item))

    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchFerpaDetailById = (ferpaId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.FERPA}/${ferpaId}`
    const { data } = await fetch(url)
    // modifyProgramItem(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const addFerpaForCall = (payload, successCallback, failureCallback) => async (dispatch) => {
  modifyUpdateFerpaCall(payload)

  // modifyUpdateFerpaCall(payload)
  const url = `${API.CORE.FERPA}`
  try {
    await post(url, payload)
    dispatch(
      messageAction({
        subTitle: 'message:RecordsAdded',
        severity: MESSAGE_SEVERITIES.SUCCESS,
      })
    )
    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const updateFerpaDetailsCall =
  (id, payload, successCallback, failureCallback) => async (dispatch) => {
    modifyUpdateFerpaCall(payload)
    try {
      await put(`${API.CORE.FERPA}/${id}`, payload)
      dispatch(
        messageAction({
          subTitle: 'message:RecordsUpdated',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const deleteFerpaCall = (id, successCallback, errorCallback) => async (dispatch) => {
  try {
    const apiPath = `${API.CORE.FERPA}/${id}`
    const response = await remove(apiPath, {})
    dispatch(
      messageAction({
        subTitle: 'message:RecordsDeleted',
        severity: MESSAGE_SEVERITIES.SUCCESS,
      })
    )
    successCallback(response.data)
  } catch (err) {
    if (typeof errorCallback === 'function') {
      errorCallback(err)
    }
  }
}

export const fetchLoginEventsCall = (pageDetails, successCallback, failureCallback) => async () => {
  try {
    if (!pageDetails.custId) {
      return
    }
    let url = `${API.CORE.LOGINEVENTS}?custId=C:${pageDetails.custId || ''}&page=${
      pageDetails.current_page || ''
    }&perPage=${pageDetails.per_page || ''}&sortBy=${pageDetails.sort_by || ''}&sortOrder=${
      pageDetails.sort_order || ''
    }&eventCode=${pageDetails.q || ''}&realm=${pageDetails.realmId || ''}`
    if (pageDetails.fromDate) {
      url += `&startDate=${moment(pageDetails.fromDate).format('YYYY-MM-DD')}T00:00:00`
    }
    if (pageDetails.toDate) {
      url += `&endDate=${moment(pageDetails.toDate).format('YYYY-MM-DD')}T23:59:59`
    }
    const { data } = await fetch(url)
    get(data, 'content', []).forEach((item) => modifyLoginEvents(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchCanvasHistory = (pageDetails, successCallback, failureCallback) => async () => {
  try {
    if (!pageDetails.custId) {
      return
    }
    let url = `${API.CORE.CANVASHISTORY}?user_urn=${pageDetails.custId || ''}&page=${
      pageDetails.current_page || ''
    }&perPage=${pageDetails.per_page || ''}&sortBy=${pageDetails.sort_by || ''}&sortOrder=${
      pageDetails.sort_order || ''
    }&application_name=${CANVAS}`
    if (pageDetails.fromDate) {
      url += `&fromDate=${moment(pageDetails.fromDate).format('YYYY-MM-DD')}T00:00:00`
    }
    if (pageDetails.toDate) {
      url += `&toDate=${moment(pageDetails.toDate).format('YYYY-MM-DD')}T23:59:59`
    }
    const { data } = await fetch(url)
    get(data, 'content', []).forEach((item) => modifyCanvasHistory(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchLastAttendance = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.LASTATTENDANCE}?email=${payload?.userEmail || ''}&schoolId=${
      payload?.schoolId || ''
    }`
    const { data } = await fetch(url)
    modifyLastAttendance(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

const modifyCanvasHistory = function (data) {
  if (isEmpty(data)) {
    return
  }
  data.loginDateLabel = formatDate(data?.login_time, DATEFORMAT)
  data.loginTimeLabel = formatDate(data?.login_time, TIMEFORMAT)
}
const modifyLastAttendance = function (data) {
  if (isEmpty(data)) {
    return
  }
  data.lda = !isNullOrEmpty(data.lda) ? formatDate(data?.lda, DATEFORMATWITHTIME) : ''
}
const modifyLoginEvents = function (data) {
  if (isEmpty(data)) {
    return
  }
  data.timeStamp = data?.timestamp ? convertTimestampToDate(data.timestamp) : ''
}

const modifyUserItem = function (data) {
  if (isEmpty(data)) {
    return
  }
  data.dobLabel = data?.dob
}

const modifyGetCall = (data) => {
  data.frp_phone = data.frp_phone
    ? data.frp_phone_prefix === UsPhoneCode
      ? getDashAddedPhone(data.frp_phone)
      : data.frp_phone
    : ''
}

const modifyFiles = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.id = item.fl_id.toString()
  item.createdTimeLabel = formatDate(item.created_at, DATEFORMATWITHTIME)
  item.updatedTimeLabel = formatDate(item.updated_at, DATEFORMATWITHTIME)
  item.fl_purge_on = formatDate(item.fl_purge_on, DATEFORMATWITHTIME)
}

const modifyUpdateFerpaCall = (data) => {
  data.frp_phone = data?.frp_phone ? getDashRemovedPhone(data.frp_phone) : ''
}
